export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER = "SET_USER";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const SET_PAGE_SIZES = "SET_PAGE_SIZES";
export const SET_USER_ROLEID = "SET_USER_ROLEID";
export const SET_MENU = "SET_MENU";